import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const NotificationCenterState = Record({
    fetching: true,
    offset: 0,
    limit: 10,
    notifications: List(),
    canLoadMore: true,
});

const canLoadMore = (response, limit) => response && response.size >= limit;

export default handleActions(
    {
        [Actions.fetch.type]: () =>
            new NotificationCenterState({
                fetching: true,
            }),
        [Actions.fetchFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                offset: state.offset + state.limit,
                notifications: state.notifications.concat(payload.response),
                canLoadMore: canLoadMore(payload.response, state.limit),
            }),
        [Actions.fetchMore.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchMoreFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchMoreSuccess.type]: (state, {payload}) => {
            return state.merge({
                fetching: false,
                offset: state.offset + state.limit,
                notifications: state.notifications.concat(payload.response),
                canLoadMore: canLoadMore(payload.response, state.limit),
            });
        },
        [Actions.markAllNotificationsAsSeenSuccess.type]: state => {
            const now = new Date().toString();
            return state.merge({
                notifications: state.notifications.map(notification => notification.merge({seenDate: now})),
            });
        },
        [Actions.markNotificationAsReadSuccess.type]: (state, {payload}) => {
            const now = new Date().toString();
            return state.merge({
                notifications: state.notifications.map(notification => {
                    if (notification.notificationId === payload.notificationId) {
                        return notification.merge({readDate: now});
                    }
                    return notification;
                }),
            });
        },
    },
    new NotificationCenterState(),
);
